<script>
import httpService from '@/core/api/request'
export default {
  data: function () {
    return {
      groups: null
    }
  },
  methods: {
    getGroups: function () {
      let httpRequest = {
        params: '',
        module: 'gallery_groups'
      }
      this.get(httpRequest)
        .then(
          groups => {
            this.groups = groups.data
          }
        ).catch(
          () => {
            this.groups = null
          }
        )
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/galleries/mixins.vue